import React from 'react'
import dayjs from 'dayjs'
import clsx from 'clsx'
import type { JoueurType, RowDetailsEntry } from '../../data'
import { NumberBlock, NumberBlockProps } from './NumberBlock'
import { useStatsJoueursDataContext } from '../../../../contexts/StatsJoueursDataContext'
import styles from './styles.module.scss'
import { deduceWinner } from '../../../types'

const getButOuArretNumberBlockProps: {
    [x in JoueurType]: (data: RowDetailsEntry) => NumberBlockProps
} = {
    joueur_de_champ: (x) => ({ number: x.buts, text: 'But', tooltip: 'Buts' }),
    gardien: (x) => ({ number: x.arrets, text: 'Arrêt', tooltip: 'Arrêts' }),
}

export const StatsJoueurDetailRow = ({ data }: { data: RowDetailsEntry }) => {
    const { isDesktop, joueurType } = useStatsJoueursDataContext()

    const winner = deduceWinner({ home: data.equipe1Score, away: data.equipe2Score })

    const dateText = data.rencontreDate
        ? dayjs(data.rencontreDate).format('ddd DD MMM - HH[H]mm').toUpperCase()
        : ''

    const dateTooltip = data.rencontreDate
        ? `${dayjs(data.rencontreDate).format('LLLL')} : ${dayjs(data.rencontreDate).fromNow()}`
        : 'Date inconnue'

    return (
        <div className={styles.row}>
            {isDesktop ? (
                <>
                    <div className={styles.date} title={dateTooltip}>
                        {dateText}
                    </div>
                    <div className={styles.scoresWrapper}>
                        <div className={styles.equipe1}>{data.equipe1Libelle}</div>
                        <div className={clsx(styles.score1, winner === 'home' && styles.winner)}>
                            {data.equipe1Score ?? '-'}
                        </div>
                        <div className={clsx(styles.score2, winner === 'away' && styles.winner)}>
                            {data.equipe2Score ?? '-'}
                        </div>
                        <div className={styles.equipe2}>{data.equipe2Libelle}</div>
                    </div>
                </>
            ) : (
                <div className={styles.mobileTextGroup}>
                    <div title={dateTooltip}>{dateText}</div>
                    <div className={styles.mobileScoreWrapper}>
                        <div className={winner === 'home' ? styles.mobileWinner : ''}>
                            {data.equipe1Score ?? '-'}
                        </div>
                        <div className={winner === 'home' ? styles.mobileWinner : ''}>
                            {data.equipe1Libelle}
                        </div>
                        <div className={winner === 'away' ? styles.mobileWinner : ''}>
                            {data.equipe2Score ?? '-'}
                        </div>
                        <div className={winner === 'away' ? styles.mobileWinner : ''}>
                            {data.equipe2Libelle}
                        </div>
                    </div>
                </div>
            )}

            <div className={styles.numberBlocks}>
                <NumberBlock {...getButOuArretNumberBlockProps[joueurType](data)} />
                <NumberBlock number={data.deuxMins} text="2 Mins." tooltip="2 minutes" />
                <NumberBlock number={data.avertissements} text="Avert." tooltip="Avertissements" />
                <NumberBlock number={data.disqualifie} text="Dis" tooltip="Disqualifié" />
            </div>
        </div>
    )
}
